import { Responsive } from '@cian/ui-kit';
import { Button, IconButton } from '@cian/ui-kit/button';
import { IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './Favorites.css';

export interface IFavoritesProps {
  isMobileActionGroup?: boolean;
  onClick(event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>): void;
}

export const Favorites: React.FunctionComponent<IFavoritesProps> = ({ isMobileActionGroup, onClick }) => {
  if (isMobileActionGroup) {
    return (
      <IconButton
        icon={<IconToggleHeartOn16 color="icon-negative-default" />}
        onClick={onClick}
        title="В избранном"
        aria-label="Удалить из избранного"
        data-name="RemoveFavoriteIconButton"
        data-testid="RemoveFavoriteIconButton"
      />
    );
  }

  return (
    <>
      <Responsive phone>
        <div
          className={styles['icon']}
          onClick={onClick}
          data-name="RemoveFavoriteIconButton"
          data-testid="RemoveFavoriteIconButton"
        >
          <IconToggleHeartOn16 color="icon-negative-default" />
        </div>
      </Responsive>
      <Responsive tablet>
        <Button
          size="XS"
          beforeIcon={<IconToggleHeartOn16 color="icon-main-default" />}
          theme="stroke_primary"
          onClick={onClick}
        >
          В избранном
        </Button>
      </Responsive>
    </>
  );
};
